/**
 * ContactSection Component
 *
 * Embedded contact cards on the landing page - email and WhatsApp.
 * Styled consistently with other landing sections.
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { FadeIn } from './FadeIn';

library.add(faEnvelope, faWhatsapp);

export function ContactSection() {
  const whatsappNumber = '5511999999999';
  const whatsappUrl = `https://wa.me/${whatsappNumber}`;

  return (
    <section className="container py-16 md:py-24 lg:py-32">
      <FadeIn>
        <div className="mx-auto flex max-w-[58rem] flex-col items-center justify-center gap-4 text-center mb-12">
          <div className="rounded-2xl bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary">
            Fale Conosco
          </div>
          <h2 className="font-heading text-3xl font-bold leading-[1.1] sm:text-4xl md:text-5xl">
            Como podemos <span className="text-primary">ajudar?</span>
          </h2>
          <p className="max-w-[85%] leading-normal text-muted-foreground sm:text-lg sm:leading-7">
            Dúvidas sobre planos, suporte técnico ou informações sobre a plataforma. Escolha o canal de sua preferência.
          </p>
        </div>
      </FadeIn>

      <FadeIn className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
        <a
          href={`mailto:support@examfy.com.br`}
          className="rounded-xl border bg-card text-card-foreground shadow-sm p-8 flex flex-col items-center text-center gap-4 hover:border-primary/40 hover:shadow-md transition-all group"
        >
          <div className="h-14 w-14 rounded-full bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
            <FontAwesomeIcon icon={faEnvelope} className="text-2xl" />
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-1">E-mail</h3>
            <p className="text-sm text-muted-foreground">support@examfy.com.br</p>
          </div>
          <span className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-6">
            Enviar e-mail
          </span>
        </a>

        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-xl border bg-card text-card-foreground shadow-sm p-8 flex flex-col items-center text-center gap-4 hover:border-green-500/40 hover:shadow-md transition-all group"
        >
          <div className="h-14 w-14 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-green-600 dark:text-green-400 group-hover:bg-green-500 group-hover:text-white transition-colors">
            <FontAwesomeIcon icon={faWhatsapp} className="text-2xl" />
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-1">WhatsApp</h3>
            <p className="text-sm text-muted-foreground">Resposta rápida em horário comercial</p>
          </div>
          <span className="inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors bg-green-600 text-white hover:bg-green-700 h-10 px-6">
            Abrir WhatsApp
          </span>
        </a>
      </FadeIn>
    </section>
  );
}
